import { useQuery } from "react-query";
import { getAdminUnregisteredAadeCases } from "src/aadeCase/data-access/gateway";
import { MRT_PaginationState } from "material-react-table";
import React from "react";

function useGetAdminUnregisteredAadeCases({
  searchFilters,
  enableSearch,
  setEnableSearch,
  paginationState,
}: {
  searchFilters: Object;
  enableSearch: Boolean;
  setEnableSearch: React.Dispatch<React.SetStateAction<Boolean>>;
  paginationState: MRT_PaginationState;
}) {
  return useQuery({
    queryFn: () =>
      getAdminUnregisteredAadeCases(searchFilters, paginationState),
    queryKey: ["getAdminUnregisteredAadeCases", paginationState, searchFilters],
    onSettled: () => {
      setEnableSearch(false);
    },
    enabled: !!enableSearch,
  });
}

export default useGetAdminUnregisteredAadeCases;
